<script setup lang="ts">
import { useNotificationStore } from '~/store/notificationStore';

const props = defineProps<{
  code: string
  tclzCategory: string
  message: string
}>()

const {
  code,
  tclzCategory,
  message
} = toRefs(props)

const copied = ref(false);

const { displayNotification } = useNotificationStore()

const copyCode = () => {
  copied.value = true;
  navigator.clipboard.writeText(code.value)
  displayNotification(message.value)
  setTimeout(() => {
    copied.value = false;
  }, 5000)
}
</script>

<template>
  <button
class="cbtn cbtn--medium cbtn--copy"
          data-tclz-selector="copy_voucher_code"
          :data-tclz-label="code"
          :data-tclz-category="tclzCategory"
          @click="copyCode">
    <input type="text" hidden :value="code">
    <span class="size--subheadline df aic mr-2">{{ code }}</span>
    <svg v-if="!copied" class="cicon cicon--12 cbtn--copy__copy-icon">
      <use xlink:href="#copy"/>
    </svg>
    <svg v-if="copied" class="cicon cicon--12 cbtn--copy__check-icon">
      <use xlink:href="#check"/>
    </svg>
  </button>
</template>

<style scoped>
</style>
